import { Checkbox, Col, Form, FormListFieldData, Row, Typography } from "antd";
import React, { useState } from "react";
import { ListingViewProps } from "../CreateComponents/interface";
import ListingGridItemCard from "../Components/ListingGridItemCard";
import ListingModal from "../Components/ListingModal";
import { ListingProperties } from "../../../types/listing.type";

const { Text } = Typography;
const ListingGridView: React.FC<ListingViewProps> = ({
	onShowSingleTransfer,
	filterItem,
	disablePickSingle,
	onCheckAll,
	fieldName,
	checkAllState,
}) => {
	const [showDetail, setShowDetail] = useState<ListingProperties | undefined>();

	const renderFields = (fields: FormListFieldData[]) => {
		if (filterItem) {
			fields = fields.filter(filterItem);
		}

		if (fields.length < 1) {
			return (
				<div
					className="center"
					style={{ marginTop: 10 }}
				>
					<Text type="secondary">Listing Empty</Text>
				</div>
			);
		}

		return (
			<Row
				gutter={[24, 24]}
				style={{ padding: "20px 10px", margin: 0 }}
			>
				{fields.map((field) => (
					<Col span={12}>
						<Form.Item
							noStyle={true}
							{...field}
						>
							<ListingGridItemCard
								onPickSingle={onShowSingleTransfer}
								disablePickSingle={disablePickSingle}
								onShowDetail={setShowDetail}
							/>
						</Form.Item>
					</Col>
				))}
			</Row>
		);
	};

	return (
		<React.Fragment>
			<div className="ant-transfer-list-header">
				<Checkbox
					checked={checkAllState?.checked}
					indeterminate={checkAllState?.indeterminate}
					onChange={(e) => onCheckAll?.(e.target.checked)}
				>
					Select All
				</Checkbox>
			</div>
			<div className="ant-transfer-list-content">
				<Form.List name={fieldName}>{renderFields}</Form.List>
			</div>
			<ListingModal
				open={showDetail !== undefined}
				onClose={() => setShowDetail(undefined)}
				listing={showDetail}
			/>
		</React.Fragment>
	);
};
export default ListingGridView;
